import React, { useCallback } from "react";

import useAxios from "../../services/useAxios";

import gv from "../../assets/kits/global-variables.module.scss";

import CustomButton from "../kits/custom-button/CustomButton";
import { CustomInput } from "../kits/inputs/Input";

import { CloseIcon, SabadiTextIcon } from "../kits/Icons/Icons";
import { InputWithValidation } from "../../types/input";
import { mobileChecker } from "../../utilities/regexCheckers";
import useWindowSize from "../../hooks/useWindowSize";
import { characterPersionToEnglish } from "../../utilities/helperFunctions";
import { toast } from "react-hot-toast";

interface Props {
  mobile: InputWithValidation<string>;
  setMobile: React.Dispatch<React.SetStateAction<InputWithValidation<string>>>;
  setHashCode: React.Dispatch<React.SetStateAction<string>>;
  setAdminpanelkey?: React.Dispatch<React.SetStateAction<string>>;
  backward: () => void;
  forward: () => void;
}

const EnterPhoneNumber: React.FC<Props> = ({
  mobile,
  setMobile,
  setHashCode,
  setAdminpanelkey,
  backward,
  forward,
}) => {
  const { loading, execute: getLoginCode } = useAxios("api/getlogincode");

  const windowsSize = useWindowSize();

  const buttonSize = () => {
    if (gv.fixed_width_var < windowsSize.width!) return gv.fixed_width_var - 40;
    return (gv.fixed_width_var * windowsSize.width!) / gv.fixed_width_var - 40;
  };

  const onClickHandler = useCallback<
    React.MouseEventHandler<HTMLButtonElement>
  >(
    async (event) => {
      event.preventDefault();
      let validate = mobile.validate;
      if (!mobile.checked) {
        validate = mobileChecker(mobile.value);
      }

      if (!validate) {
        setMobile((prev) => ({ ...prev, checked: true, validate: false }));
        return;
      }

      let m = mobile.value.trim().replace(/[-\s]+/g, "");
      if (m.startsWith("+98")) {
        m = m.replace("+98", "0");
      }
      getLoginCode({ mobile: m }).then((res) => {
        if (+res.status === 1) {
          setHashCode(res.data.hashcode);
          setAdminpanelkey?.(res.data.adminpanelkey);
          setMobile((prev) => ({
            ...prev,
            value: m,
          }));
          forward();
        }
      });
    },
    [mobile, getLoginCode, setHashCode, setMobile, forward]
  );

  return (
    <div
      className="enter-phonenumber-section pd-x-20 pd-t-20 pd-b-64"
      style={{ maxWidth: 600, width: "100%", height: "100%" }}
    >
      <div className="mr-b-16">
        <CustomButton
          buttonStyle="text"
          onClick={backward}
          icon={<CloseIcon />}
          iconPosition="center"
        />
      </div>
      <div className="mr-b-16">
        <SabadiTextIcon />
      </div>
      <h5 className="mr-b-6 title-h3-b">ورود به سبدی</h5>
      <form>
        <p className="mr-b-24 txt-t2-l">
          برای ورود به سبدی شماره موبایل خود را وارد کنید. کد تایید به این شماره
          پیامک خواهد شد.
        </p>
        <CustomInput
          value={mobile.value}
          type="tel"
          placeholder="09XX XXX XX XX"
          messageText="شماره موبایل خود را وارد کنید."
          textType={mobile.checked && !mobile.validate ? "error" : "none"}
          onChange={(event) => {
            let validate = mobile.validate,
              mobileText = characterPersionToEnglish(event.target.value);

            // check that it has just numbers, not characters
            if (!/^\d*$/.test(mobileText)) {
              return;
            }
            // check that it is mobile
            if (mobile.checked === true) {
              validate = mobileChecker(mobileText);
            }
            setMobile((prev) => ({
              ...prev,
              value: mobileText,
              validate,
            }));
          }}
          onBlur={() => {
            if (mobile.checked === false) {
              setMobile((prev) => ({
                ...prev,
                checked: true,
                validate: mobileChecker(prev.value),
              }));
            }
          }}
        />
        <div className="bottom-fixed-items">
          <CustomButton
            size="large"
            type="submit"
            state={loading ? "loading" : "default"}
            onClick={onClickHandler}
            style={{
              width: buttonSize(),
            }}
          >
            ادامه
          </CustomButton>
        </div>
      </form>
    </div>
  );
};

export default EnterPhoneNumber;
